import { render, staticRenderFns } from "./PolicyProvisionImportModal.vue?vue&type=template&id=051ab987&scoped=true&"
import script from "./PolicyProvisionImportModal.vue?vue&type=script&lang=js&"
export * from "./PolicyProvisionImportModal.vue?vue&type=script&lang=js&"
import style0 from "./PolicyProvisionImportModal.vue?vue&type=style&index=0&id=051ab987&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "051ab987",
  null
  
)

export default component.exports